import script from "./UiAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UiAvatar.vue?vue&type=script&setup=true&lang=js"

import "./UiAvatar.vue?vue&type=style&index=0&id=7e5c9cf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5c9cf5"]])

export default __exports__